/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';

export const IconWarning = ({ strokeClassName = 'stroke-color-gsMiddleLT', fillClassName = 'fill-color-gsMiddleLT', width = 134, height = 134 }) => (
  <svg width={width} height={height} viewBox="0 0 135 135" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.4983 47.9639H5.66024L4.90773 14.3623H13.2836L12.4983 47.9639ZM4.6787 58.2374C4.6787 56.9941 5.08222 55.9689 5.88927 55.1619C6.69632 54.333 7.79783 53.9186 9.19381 53.9186C10.5898 53.9186 11.6913 54.333 12.4983 55.1619C13.3054 55.9689 13.7089 56.9941 13.7089 58.2374C13.7089 59.4371 13.3163 60.4404 12.5311 61.2475C11.7458 62.0545 10.6334 62.4581 9.19381 62.4581C7.75421 62.4581 6.64179 62.0545 5.85655 61.2475C5.07132 60.4404 4.6787 59.4371 4.6787 58.2374Z"
      transform="translate(57.2351 26.5236)"
      className={fillClassName}
    />
    <path
      d="M60.0269 120.054C93.1789 120.054 120.054 93.1789 120.054 60.0269C120.054 26.875 93.1789 0 60.0269 0C26.875 0 0 26.875 0 60.0269C0 93.1789 26.875 120.054 60.0269 120.054Z"
      transform="translate(6.97998 6.97986)"
      className={strokeClassName}
      strokeWidth="5.5839"
    />
  </svg>
);

const xLargeStyles = {
  fill: 'none',
  strokeLineJoin: 'round',
  strokeWidth: 2.75,
};
const XLarge = ({ strokeClassName }) => (
  <svg xmlns="http://www.w3.org/2000/svg" height="56" width="56" viewBox="0 0 56 56">
    <g>
      <circle className={strokeClassName} style={xLargeStyles} cx="28" cy="28" r="23.33"/>
      <line className={strokeClassName} style={xLargeStyles} x1="28" y1="14.75" x2="28" y2="34.19"/>
      <line className={strokeClassName} style={xLargeStyles} x1="28" y1="37.13" x2="28" y2="41.25"/>
    </g>
  </svg>
);

const LargeStyles = {
  fill: 'none',
  strokeMiterlimit: 10,
  strokeWidth: 2,
};

const Large = ({ strokeClassName }) => (
  <svg xmlns="http://www.w3.org/2000/svg" height="36" width="36" viewBox="0 0 36 36">
    <g>
      <circle className={strokeClassName} style={LargeStyles} cx="18.18" cy="18" r="15"/>
      <line className={strokeClassName} style={LargeStyles} x1="18.18" y1="9.48" x2="18.18" y2="21.98"/>
      <line className={strokeClassName} style={LargeStyles} x1="18.18" y1="24.37" x2="18.18" y2="26.52"/>
    </g>
  </svg>
);

const MediumStyles = {
  fill: 'none',
  stroke: '#000',
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
};

const Medium = () => (
  <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" viewBox="0 0 24 24">
    <g>
      <circle style={MediumStyles} cx="12" cy="12" r="9.51"/>
      <line style={MediumStyles} x1="12" y1="6.6" x2="12" y2="14.1"/>
      <line style={MediumStyles} x1="12" y1="15.62" x2="12" y2="17.4"/>
    </g>
  </svg>
);

const SmallStyles = {
  fill: 'none',
  stroke: '#000',
  strokeMiterlimit: 10,
  strokeWidth: 1.25,
};

const Small = () => (
  <svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 16 16">
    <g>
      <circle style={SmallStyles} cx="8" cy="8" r="6.57"/>
      <line style={SmallStyles} x1="8" y1="4.27" x2="8" y2="9.45"/>
      <line style={SmallStyles} x1="8" y1="10.5" x2="8" y2="11.73"/>
    </g>
  </svg>
);

const Icons = {
  Small,
  Medium,
  Large,
  XLarge,
};

export default Icons;
